import { InjectedStyledComponent } from '../../../../shared/InjectedStyledComponent.js';
import {
	DOCUMENT_DOWNLOAD_LIST_CATEGORY_KEY,
	DOCUMENT_DOWNLOAD_LIST_COMPONENT_KEY,
} from '../DocumentDownloadList.meta.js';

export default InjectedStyledComponent(
	'section',
	DOCUMENT_DOWNLOAD_LIST_CATEGORY_KEY,
	DOCUMENT_DOWNLOAD_LIST_COMPONENT_KEY,
	['wrapper'],
);
